/**
 * Keep Patternslib's own modal out of Plone's modal links.
 *
 * booost.cms installs plone.patternslib (the customizer needs pat-inject and
 * pat-autosubmit), and its bundle registers Patternslib's `modal` next to
 * Mockup's `plone-modal`. collective.easyform marks the field and action
 * "Settings…" links `pat-modal pat-plone-modal`, so one click opened both:
 * Mockup's dialog, and on top of it a fixed #pat-modal (z-index 9998) holding
 * the whole page behind a 98 % white veil. The form could not be edited.
 *
 * Nothing in booost uses Patternslib's modal. plone.patternslib's preinit
 * assigns the blacklist (only `legend`), so adding to it earlier is lost. The
 * patterns arrive in async chunks, and this sync head script may run before or
 * after `modal` registers, but always before the DOMContentLoaded scan. So
 * both: blacklist it, and drop it if it is already in.
 */

if (Array.isArray(window.__patternslib_patterns_blacklist)) {
  if (!window.__patternslib_patterns_blacklist.includes('modal')) {
    window.__patternslib_patterns_blacklist.push('modal')
  }
} else {
  window.__patternslib_patterns_blacklist = ['modal']
}

if (window.__patternslib_registry && window.__patternslib_registry.modal) {
  delete window.__patternslib_registry.modal
}
